
        var result = require("!!../../../../node_modules/css-loader/index.js!./spinner.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/styles/common/spinner.component.css
// module id = 484
// module chunks = 0